import { IconProps } from '@models/icons';

function FavoriteCircleFill({ size = 32, color = '#6E6864' }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.2334" cy="16" r="11.7092" fill={color} stroke={color} strokeWidth="1.41843"/>
            <path
                d="M18.898 12.6279C19.4389 12.6279 19.972 12.8611 20.3766 13.2998V13.3008C20.781 13.7473 21.0172 14.3622 21.0172 15.0146C21.0171 15.6578 20.7862 16.2632 20.3922 16.708L16.3082 20.3281L12.2203 16.7051C11.8284 16.2606 11.5993 15.656 11.5992 15.0146C11.5992 14.4438 11.7802 13.9013 12.0963 13.4756L12.2398 13.3008C12.6445 12.8616 13.1781 12.6279 13.7193 12.6279C14.2616 12.6281 14.7959 12.8627 15.2008 13.3037L15.7857 13.9424L16.3082 14.5137L16.8316 13.9424L17.4156 13.3037C17.8206 12.8625 18.3556 12.6279 18.898 12.6279Z"
                fill="white" stroke="white" strokeWidth="1.41843"/>
        </svg>

    );
}

export default FavoriteCircleFill;
